module.exports = __webpack_public_path__ + "static/media/bg.36d2fbb8.png";